import { BigNumber } from "ethers";
import { FC, useState } from "react";
import { STAGES } from "../../../types";
import { useMyInterval, zeroNum } from "../../../utils";
import { Dashboard, findAuctionIndex } from "../../../web3/web3-hooks";

export const AuctionTime: FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
  const [nextTime, setNextTime] = useState(0);

  useMyInterval(() => {
    let currentStage = BigNumber.from(
      dashboard.currentStage as number
    ).toNumber();

    // auction时
    if (currentStage === STAGES.AUCTION_RUNNING) {
      const finalSupply = BigNumber.from(
        dashboard.auction_supply_list[dashboard.auction_supply_list.length - 1]
      ).toNumber();
      const minted_auction = BigNumber.from(
        dashboard.minted_auction
      ).toNumber();
      const auctionSoldOut = minted_auction >= finalSupply;
      if (auctionSoldOut) {
        currentStage = STAGES.AUCTION_END;
      } else {
        const data = findAuctionIndex(dashboard);
        const { time, index } = data;
        // console.log("time = ", time, "index = ", index);
        setNextTime(time);
        return;
      }
    }
    const nextTimeMap: Record<number, any> = {
      [STAGES.AUCTION_NOT_START]: dashboard.auctionStart,
      [STAGES.AUCTION_END]: dashboard.wl1Start,
      [STAGES.WL1_RUNNING]: dashboard.wl1End,
      [STAGES.WL1_END]: dashboard.wl2Start,
      [STAGES.WL2_RUNNING]: dashboard.wl2End,
      [STAGES.WL2_END]: dashboard.publicStart,
      [STAGES.PUBLIC_RUNNING]: dashboard.publicEnd,
      [STAGES.PUBLIC_END]: 0,
    };
    setNextTime(
      BigNumber.from(nextTimeMap[currentStage] as BigNumber).toNumber()
    );
  }, 1000);
  if (nextTime === 0) return <div></div>;
  return <RoundTimer nextTime={nextTime}></RoundTimer>;
};

export const RoundTimer: FC<{ nextTime: number }> = ({ nextTime }) => {
  const [curTime, setCurTime] = useState("");
  const [visible, setVisible] = useState(true);
  useMyInterval(() => {
    const now = Math.ceil(Date.now() / 1000);
    var resume = nextTime - now;
    if (resume >= 0) {
      setVisible(true);
    } else {
      console.warn(`resume = `, resume, `now = ${now}, nextTime = ${nextTime}`);
      setCurTime("waiting...");
      return;
    }
    let hour = 0;
    let min = Math.floor(resume / 60);
    const sec = resume % 60;
    if(min >= 60) {
      hour = Math.floor(min / 60);
      min = min % 60;
    }
    if(hour === 0) {
      setCurTime(`${zeroNum(min)}:${zeroNum(sec)}`);
    } else {
      setCurTime(`${zeroNum(hour)}:${zeroNum(min)}:${zeroNum(sec)}`);
    }
  }, 1000);
  if (visible && curTime)
    return <div className="round-auction-time">{curTime}</div>;
  return <div></div>;
};
